import FilterController from "../Controller"

export default {
  props: [
    "value",
    "allProps",
    "pagination",
    "label",
    "needSearch",
    "hasOtherFilter",
  ],

  components: {
    FilterController,
  },

  data() {
    console.log("this.value.filters", this.value.filters)
    return {
      allFilters: this.value.filters,
    }
  },
  methods: {
    handleFilter(parameters) {
      this.$emit("input", parameters)
    },
  },
}
